import type { FC } from 'react';
import React from 'react';
import type { FieldRenderProps } from 'react-final-form';
import { Field as FinalField } from 'react-final-form';
import { validateNotEmpty } from '@alfa-bank/site-form-helpers/validation/not-empty';
import { RadioTagsDesktop as RadioTags } from '@alfa-bank/site-radio-tags/desktop';
import { sendEvent } from '@alfa-bank/site-helpers-common/browser/send-event';

import type { IPropsRadioTagsController, TRadioTags } from '../models';
import { defaultHandler } from '../field/config';

import { genderDefault, genders } from './config';

export const RadioTagsController: FC<IPropsRadioTagsController> = ({
    analytics,
    className,
    genderSettings,
    name,
    onChange = defaultHandler,
    size,
}) => {
    const settings = {
        gender: { ...genderDefault, ...genderSettings },
    };

    const onRadioTagsHandler: TRadioTags =
        gender =>
        ({ name: fieldName, value }) => {
            if (analytics?.gender) sendEvent(analytics.gender);

            if (onChange) {
                onChange({ name: fieldName, value });
            }
            gender.input.onChange(value);
        };

    return (
        <div className={className}>
            <FinalField
                name={name}
                render={gender => (
                    <RadioTags
                        {...settings.gender}
                        error={gender.meta.invalid && gender.meta.touched}
                        onSelect={onRadioTagsHandler(gender as FieldRenderProps<string>)}
                        selected={gender.input.value}
                        size={size}
                        tags={genders}
                    />
                )}
                validate={validateNotEmpty()}
            />
        </div>
    );
};
